"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.Container = ({ children }) => {
    return React.createElement("div", { className: 'clp-container' }, children);
};
//# sourceMappingURL=Container.js.map